import { useMediaQuery } from '@mui/material';

const useShouldUseSmallScreenVersion = (): boolean => {
  const shouldUseSmallScreenVersion = useMediaQuery('(max-width: 850px)');

  return shouldUseSmallScreenVersion;
};

export default useShouldUseSmallScreenVersion;
